import { render, staticRenderFns } from "./asset-group.vue?vue&type=template&id=4feb1974"
import script from "./asset-group.vue?vue&type=script&lang=js"
export * from "./asset-group.vue?vue&type=script&lang=js"
import style0 from "./asset-group.vue?vue&type=style&index=0&id=4feb1974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports